import { API } from "../config";


const login = (mobile_no: string | number) =>
    API.post("/check/mobile", { mobile_no }).then(
        (res) => res,
        (err) => err.response
    );

export const sendOtp = (mobile_no: string | number) =>
    API.post("/send/otp", { mobile_no }).then(
        (res) => res,
        (err) => err.response
    );

export const guestOtp = (country_code: string | number,number: string | number, name: string) =>
    API.post("/send/guest/otp", { country_code, number, first_name: name }).then(
        (res) => res,
        (err) => err.response
    );
export const checkGuestOtp = (res: { OTP: string, phoneNumber: string, countryCode: string, firstName: any }) =>
    API.post("/check/guest/otp", {

        code: res.OTP,
        country_code: res.countryCode,
        number: res.phoneNumber,
        first_name: res.firstName

    }).then(
        (res) => res,
        (err) => err.response
    );

export const socialLogin = (res: { userEmail: string, Title: string, titleValue: string, loginSource: string }) =>
    API.post("/social/login", {
        username: res.userEmail,
        title: res.Title,
        value: res.titleValue,
        source: res.loginSource
    }).then(
        (res) => res,
        (err) => err.response
    );


export const customerUpdateProfile = (userObj: { first_name: string, last_name: string, email: string, user_id: string, dob: string, gender: string }, token: string, userId: number) =>
    API.post("/customer/profile", {
        first_name: userObj.first_name,
        last_name: userObj.last_name,
        email: userObj.email,
        user_id: userId,
        dob: userObj.dob,
        gender: userObj.gender
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": `multipart/form-data`,
        },
    }).then(
        (res) => res,
        (err) => err.response
    );
export const authService = {
    login,
    sendOtp,
    guestOtp,
    socialLogin,
    checkGuestOtp,
    customerUpdateProfile
};